import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import _ from 'underscore';
// import moment from 'moment'
import { acBilet } from '../actions/acBilet'
import Dropdown from 'react-dropdown'

class Future extends React.Component {

    selectedFuture(e) {
        var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab }),
            futureArr = [], findBiletTimeStart = findBilet ? findBilet.timeStart : null, rundeArr = []
            
            for (let i = 0; i < this.props.runde.length; i++) {
                rundeArr.push(this.props.runde[i].timeStart)
            }
            if(findBiletTimeStart && parseInt(e.value) > 0) {
                var rai = _.indexOf(rundeArr, findBiletTimeStart);
                futureArr = rundeArr.slice(rai, rai + parseInt(e.value) + 1)
            }

        var values = {
            position: this.props.biletTab,
            future: e.value,
            futureArr: futureArr
        }
        this.props.acBilet(['future', values])
    }
    selectedValue() {
        var findBiletThis = _.findWhere(this.props.bilete, { position: this.props.biletTab });
        if (findBiletThis !== undefined) {
            return findBiletThis.future.toString()
        }

    }
    optionssDD() {
        return ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20']
    }
    render() {
        if (this.props.appProps.future === true) {
            return (
                <div className="con-future">
                    <div className="title">{this.props.multiLang.repeatBet.txt}</div>
                    <img id="info-img" src="img/icon/info.svg" alt="" title={this.props.multiLang.repeatBetInfo.txt} />
                    <div className="con-dropdown">
                        <Dropdown options={this.optionssDD()} value={this.selectedValue()} onChange={this.selectedFuture.bind(this)} />
                    </div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        biletTab: state.biletTab,
        bilete: state.bilete,
        multiLang: state.multiLang,
        runde: state.runde
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBilet: acBilet
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(Future);